import { render, staticRenderFns } from "./appraiseRanking.vue?vue&type=template&id=3f4ef318&scoped=true"
import script from "./appraiseRanking.vue?vue&type=script&lang=js"
export * from "./appraiseRanking.vue?vue&type=script&lang=js"
import style0 from "./appraiseRanking.vue?vue&type=style&index=0&id=3f4ef318&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ef318",
  null
  
)

export default component.exports